import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import config from '../../../../config';
import DataComponentFinanceBlock from "../../../DataComponent/DataComponentFinanceBlock";
import {getPayouts} from "./PayoutPageContainer.selectors";
import localStorage from '../../../../helpers/localStorage';
import { I18nContext } from 'utils/I18n/context';

const columnTableData = {
    header: {},
    body: {}
};
const nameLocalStorage = 'payoutPage';

const PayoutPageContainer = ({
    payouts,
    totalPages,
    headerNames,
    loading,
    selectOptions,
    getPayouts
}) => {
    const { t } = useContext(I18nContext);
    const [state, setState] = useState({
        payouts: payouts || [],
        totalPages: totalPages || 0,
        headerNames: headerNames || [],
        loading: loading || false
    });

    const staticNameTable = t?.dataTable || {
        headers: { createdAt: 'Created At', status: 'Status' },
        filter: 'Filter',
        tips: { byStatus: 'By Status' }
    };

    const onDataTableAction = useCallback((state) => {
        getPayouts(state);
    }, [getPayouts]);

    useEffect(() => {
        setState(prev => ({
            ...prev,
            payouts: payouts || [],
            totalPages: totalPages || 0,
            loading: loading || false
        }));
    }, [payouts, totalPages, loading]);

    useEffect(() => {
        localStorage.set(nameLocalStorage, document.location.search);
    }, []);

    return (
        <DataComponentFinanceBlock
            onAction={onDataTableAction}
            totalPages={state.totalPages}
            headerNames={state.headerNames}
            data={state.payouts}
            loading={state.loading}
            isQuery={true}
            columnData={columnTableData}
            className="simple-table payout-table"
            gray={true}
            fields={[
                {
                    name: 'datepicker',
                    key: 'create',
                    label: staticNameTable.headers.createdAt,
                    dropdownLabel: staticNameTable.filter,
                    disabled: true,
                    value: {
                        startDate: moment().subtract(config.defaultDatepickerMonthPayoutPeriod, 'month')
                    }
                },
                {
                    name: 'multiselect',
                    key: 'statuses',
                    data: selectOptions || [],
                    label: staticNameTable.headers.status,
                    dropdownLabel: staticNameTable.filter,
                    placeholder: staticNameTable.tips.byStatus
                }
            ]}
        />
    );
};

PayoutPageContainer.propTypes = {
    payouts: PropTypes.array,
    totalPages: PropTypes.number,
    headerNames: PropTypes.array,
    loading: PropTypes.bool,
    selectOptions: PropTypes.array,
    getPayouts: PropTypes.func
};

PayoutPageContainer.defaultProps = {
    payouts: [],
    totalPages: 0,
    headerNames: [],
    loading: false,
    selectOptions: [],
    getPayouts: () => {}
};

export { PayoutPageContainer };
